import { CheckCircle, Users, Award, Building } from 'lucide-react';

interface CredibilitySectionProps {
  visible: boolean;
}

const CredibilitySection = ({ visible }: CredibilitySectionProps) => {
  const metrics = [
    {
      icon: CheckCircle,
      number: "38,000+",
      label: "Career Assessments Completed",
      description: "Students have found their career path"
    },
    {
      icon: Award,
      number: "92%",
      label: "Student Satisfaction Rate",
      description: "Highly rated by our users"
    },
    {
      icon: Building,
      number: "20+",
      label: "Trusted by Schools, Colleges & NGOs",
      description: "Educational institutions trust us"
    }
  ];

  return (
    <section className={`py-16 px-4 sm:px-6 md:px-8 bg-gradient-to-r from-blue-50 to-indigo-50 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-4">
            Trusted by Thousands
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join the thousands of students and professionals who have discovered their career potential with our proven assessment platform
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {metrics.map((metric, index) => {
            const IconComponent = metric.icon;
            return (
              <div 
                key={index}
                className="text-center p-8 bg-white rounded-2xl shadow-soft hover:shadow-elevated transition-all duration-300 hover:-translate-y-1"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-brand-blue to-brand-lightBlue rounded-full mb-6">
                  <IconComponent className="h-8 w-8 text-white" />
                </div>
                <div className="mb-4">
                  <h3 className="text-4xl font-bold text-brand-blue mb-2">
                    {metric.number}
                  </h3>
                  <h4 className="text-xl font-semibold text-gray-800 mb-2">
                    {metric.label}
                  </h4>
                  <p className="text-gray-600">
                    {metric.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;